import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import * as api from "../../api/index";

const AdminCreateNotification = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    title: "",
    message: "",
    type: "general",
    link: "",
  });
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMsg("");
    setErrorMsg("");

    try {
      setLoading(true);
      await api.postAdminNotification(form);

      setSuccessMsg("✅ Notification sent successfully!");
      setForm({
        title: "",
        message: "",
        type: "general",
        link: "",
      });
    } catch (err) {
   
      setErrorMsg(
        err?.response?.data?.message || "❌ Failed to send notification"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6 flex flex-col">
      {/* 🔙 Back Button at very top */}
      <button
        onClick={() => navigate(-1)}
        className="mb-6 flex items-center gap-2 text-gray-600 hover:text-gray-900"
      >
        <FiArrowLeft size={20} />
        <span className="text-sm">Back</span>
      </button>

      {/* Center the box in middle of page */}
      <div className="flex flex-1 justify-center items-center">
        <form
          onSubmit={handleSubmit}
          className="bg-white p-6 rounded-xl shadow-md w-full max-w-lg"
        >
          <h1 className="text-2xl font-bold text-gray-800 mb-6 text-center">
            Create Notification
          </h1>

          {/* Success/Error Messages */}
          {successMsg && (
            <p className="mb-4 text-green-600 font-medium">{successMsg}</p>
          )}
          {errorMsg && (
            <p className="mb-4 text-red-600 font-medium">{errorMsg}</p>
          )}

          {/* Title */}
          <label className="block mb-2 text-sm font-medium text-gray-700">
            Title
          </label>
          <input
            type="text"
            name="title"
            value={form.title}
            onChange={handleChange}
            required
            className="w-full p-2 mb-4 border rounded-lg"
            placeholder="Enter notification title"
          />

          {/* Message */}
          <label className="block mb-2 text-sm font-medium text-gray-700">
            Message
          </label>
          <textarea
            name="message"
            value={form.message}
            onChange={handleChange}
            required
            rows="4"
            className="w-full p-2 mb-4 border rounded-lg"
            placeholder="Enter notification message"
          />

          {/* Type */}
          <label className="block mb-2 text-sm font-medium text-gray-700">
            Type
          </label>
          <select
            name="type"
            value={form.type}
            onChange={handleChange}
            className="w-full p-2 mb-4 border rounded-lg"
          >
            <option value="general">General</option>
            <option value="alert">Alert</option>
            <option value="payment">Payment</option>
          </select>

          {/* Link */}
          <label className="block mb-2 text-sm font-medium text-gray-700">
            Link (optional)
          </label>
          <input
            type="text"
            name="link"
            value={form.link}
            onChange={handleChange}
            className="w-full p-2 mb-4 border rounded-lg"
            placeholder="https://example.com"
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-orange-500 text-white py-2 px-4 rounded-lg hover:bg-orange-600 disabled:opacity-50"
          >
            {loading ? "Sending..." : "Send Notification"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminCreateNotification;
